module.exports = __webpack_public_path__ + "images/paypal/browser_left-f796b13a.svg";